import apiUrl from '../../../constants'
import axios from 'axios'
import {Validator} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import InscanOverageShipment from './InscanOverageShipment/index.vue'
import InscanShortageShipment from './InscanShortageShipment/index.vue'
import  ApprovalStatus from './ApprovalStatus/index.vue'

export default {
  name: 'inscan-overage-shortage',
  components: {
		DatePicker,
		'first': InscanOverageShipment,
		'second': InscanShortageShipment,
		'third': ApprovalStatus
	},
	props: [],
	data() {
		return {
			currentTab: 'First',
			componentKey: 0,
			tabs: [{
					key: 'First',
					value: 'Inscan Overage Shipment'
				},
				{
					key: 'Second',
					value: 'Inscan Shortage Shipment'
				},
				{
					key: 'Third',
					value: 'Approval Status'
				}
			],
		}
	},
	computed: {
		// selects all checkbox's option
		currentTabComponent: function() {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		}
	},
	mounted() {},
	methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/InscanOverageShortage/InscanOverageShortage.js